/* eslint-disable no-console */
/* eslint-disable max-lines */
import ImageConstants from './ImageConstants';

const modes = {
    BEGINNER: 'beginner',
    INTERMEDIARY: 'intermediary',
    ADVANCED: 'advanced',
};

const focus = {
    BRANDING: 'branding',
    TRAFFIC: 'traffic',
    CONVERSION: 'conversion',
};

const kpis = {
    ROAS: 'roas', // greater is better
    CPA: 'cpa', // less is better
    CPV: 'cpv', // less is better
    CPC: 'cpc', // less is better
    CPM: 'cpm', // less is better
    CTR: 'ctr', // greater is better
};

const additionalInformationTypes = {
    TYPE_TEXT: 'text',
    TYPE_NUMBER: 'number',
    TYPE_DATE: 'date',
    TYPE_BOOLEAN: 'boolean',
    TYPE_ENUM: 'enum',
};

const customerJourneySteps = {
    AWARENESS: 'awareness',
    INTEREST: 'interest',
    DECISION: 'decision',
    ACTION: 'action',
};

const customerJourneyDescriptions = {
    [customerJourneySteps.AWARENESS]: 'Hey - What is that ?',
    [customerJourneySteps.INTEREST]: 'Let me take a closer look.',
    [customerJourneySteps.DECISION]: 'Which is the best option?',
    [customerJourneySteps.ACTION]: 'Yeah. I\'m ready to buy!',
};

/**
 * @deprecated Use ControlTypes on @domain/cards/cards.types
 */
const cardControlTypes = {
    AUTOMATIC: 'automatic',
    SEMI_AUTOMATIC: 'semi-automatic',
    MANUAL: 'manual',
    SUGGESTION: 'suggestion',
};

const cardControlTypesLabels = {
    [cardControlTypes.AUTOMATIC]: 'Automatic',
    [cardControlTypes.SEMI_AUTOMATIC]: 'Suggestions',
    [cardControlTypes.MANUAL]: 'Manual',
    [cardControlTypes.SUGGESTION]: 'Insights',
};

const cardAutomaticStatus = {
    STATUS_TODO: 'todo',
    STATUS_SCHEDULED: 'scheduled',
    STATUS_DOING: 'doing',
    STATUS_DONE: 'done',
};

const status = {
    INACTIVE: 'inactive',
    ACTIVE: 'active',
};

const statusLabels = {
    [status.INACTIVE]: 'Inactive',
    [status.ACTIVE]: 'Active',
};

const segmentTypes = {
    AGE: 'age',
    GENDER: 'gender',
};

const qualityScoreProvidersTypes = {
    AD_RELEVANCE: 'ad_quality',
    EXPECTED_CTR: 'ctr_quality',
    LANDING_PAGE_EXPERIENCE: 'lp_quality',
    QUALITY_SCORE: 'quality_score',
};

const cardMatchTypes = {
    EXACT: 'EXACT',
    PHRASE: 'PHRASE',
    BROAD: 'BROAD',
    BROAD_MODIFIED: 'BROAD_MODIFIED',
};

const campaignTypes = {
    SEARCH: 'SEARCH',
    DISPLAY: 'DISPLAY',
    SHOPPING: 'SHOPPING',
    MULTI_CHANNEL: 'MULTI_CHANNEL',
};

const campaignTypesLabels = {
    [campaignTypes.SEARCH]: 'Search',
    [campaignTypes.DISPLAY]: 'Display',
    [campaignTypes.SHOPPING]: 'Shopping',
    [campaignTypes.MULTI_CHANNEL]: 'Multi Channel',
};

const prioritiesWithIcons = {
    HIGH: {
        value: 'high',
        label: gettext('High'),
        icon: ImageConstants.ICONS.PRIORITY_HIGH.SRC,
    },
    MEDIUM: {
        value: 'medium',
        label: gettext('Medium'),
        icon: ImageConstants.ICONS.PRIORITY_MEDIUM.SRC,
    },
    LOW: {
        value: 'low',
        label: gettext('Low'),
        icon: ImageConstants.ICONS.PRIORITY_LOW.SRC,
    },
};

const priorities = {
    HIGH: 'high',
    MEDIUM: 'medium',
    LOW: 'low',
};

const cardPrioritiesLabels = {
    [priorities.HIGH]: 'High',
    [priorities.MEDIUM]: 'Medium',
    [priorities.LOW]: 'Low',
};

const historyOptionsFormatted = {
    account: 'Account',
    story_points: 'Story Points',
    activity_type: 'Activity type',
    assignee: 'Assignee',
    assignees: 'Assignees',
    campaign: 'Campaign',
    category: 'Category',
    client: 'Client',
    deadline: 'Deadline',
    description: 'Description',
    funnel_step: 'Funnel step',
    priority: 'Priority',
    status: 'Status',
    title: 'Title',
    visibility: 'Visibility',
};

const historyOptions = {
    ACTIVITY_TYPE: 'Activity type',
    CATEGORY: 'Category',
    CAMPAIGN: 'Campaign',
    DEADLINE: 'Deadline',
    DESCRIPTION: 'Description',
    TITLE: 'Title',
    STATUS: 'Status',
    VISIBILITY: 'Visibility',
    FUNNEL_STEP: 'Funnel step',
    PRIORITY: 'Priority',
};

const cardCategories = {
    BLOG: 'blog',
    EMAIL_MARKETING: 'email_marketing',
    FACEBOOK_ADS: 'facebook_ads',
    GOOGLE_ANALYTICS: 'google_analytics',
    GOOGLE_ADS: 'google_ads',
    INBOUND_MARKETING: 'inbound_marketing',
    LINKEDIN_ADS: 'linkedin_ads',
    SEO: 'seo',
    SOCIAL_MEDIA_CONTENT: 'social_media_content',
    WAZE_ADS: 'waze_ads',
    WEB_DESIGN: 'web_design',
};

const cardCategoriesLabels = {
    [cardCategories.GOOGLE_ADS]: 'Google Ads',
    [cardCategories.FACEBOOK_ADS]: 'Facebook Ads',
    [cardCategories.LINKEDIN_ADS]: 'LinkedIn Ads',
    [cardCategories.SEO]: 'SEO',
    [cardCategories.WEB_DESIGN]: 'Web Design',
    [cardCategories.EMAIL_MARKETING]: 'Email Marketing',
    [cardCategories.INBOUND_MARKETING]: 'Inbound Marketing',
    [cardCategories.SOCIAL_MEDIA_CONTENT]: 'Social Media Content',
    [cardCategories.BLOG]: 'Blog',
};

const cardActivities = {
    TASK: 'task',
    MEETING: 'meeting',
    CALL: 'call',
    EMAIL: 'email',
    NOTES: 'notes',
};

const cardActivitiesFormatted = {
    [cardActivities.TASK]: 'Task',
    [cardActivities.MEETING]: 'Metting',
    [cardActivities.CALL]: 'Call',
    [cardActivities.EMAIL]: 'E-mail',
    [cardActivities.NOTES]: 'Notes',
};

const cardVisibility = {
    TEAM: 'team',
    CLIENTS: 'clients',
};

const cardVisibilityLabels = {
    [cardVisibility.CLIENTS]: 'All',
    [cardVisibility.TEAM]: 'Team',
};

const cardFunnelAbbreviations = {
    top_of_funnel: 'TOFU',
    middle_of_funnel: 'MOFU',
    bottom_of_funnel: 'BOFU',
};

const cardFunnelFormatted = {
    top_of_funnel: 'Top of Funnel',
    middle_of_funnel: 'Middle of Funnel',
    bottom_of_funnel: 'Bottom of Funnel',
};

const cardFunnel = {
    TOP_OF_FUNNEL: 'top_of_funnel',
    MIDDLE_OF_FUNNEL: 'middle_of_funnel',
    BOTTOM_OF_FUNNEL: 'bottom_of_funnel',
};

const sidebarModalAttributes = {
    ACTIVITY: 'activity_type',
    DEADLINE: 'deadline',
    PRIORITY: 'priority',
    VISIBILITY: 'visibility',
    STATUS: 'status',
    TAGS: 'tags',
    CAMPAIGN: 'campaign',
    DESCRIPTION: 'description',
    TITLE: 'title',
};

const adsInExcessTypes = {
    ADGROUP: 'adgroup',
};

const filters = {
    ACTIVITY_TYPE: 'activity_type',
    ASSIGNEES: 'assignees',
    CAMPAIGN_NAME: 'campaign_name',
    CLASSIFICATION: 'classification',
    CONTROL_TYPE: 'control_type',
    DEADLINE: 'deadline',
    FINISHED_AT: 'finished_at',
    MANAGER: 'managers',
    PRIORITY: 'priority',
    VISIBILITY: 'visibility',
};

const filtersNames = {
    ACTIVITY_TYPE: 'Activity Type',
    ASSIGNEES: 'Owner',
    CAMPAIGN_NAME: 'Campaign Name',
    CONTROL_TYPE: 'Task Type',
    DEADLINE: 'Deadline',
    FINISHED_AT: 'Finished At',
    MANAGER: 'Manager',
    PRIORITY: 'Priority',
};

const facebookCampaignCallToActionButton = {
    CALL_BOOK_NOW: 'book_now',
    CALL_LEARN_MORE: 'learn_more',
    CALL_APPLY_NOW: 'apply_now',
    CALL_CONTACT_US: 'contact_us',
    CALL_DOWNLOAD: 'download',
    CALL_GET_OFFER: 'get_offer',
    CALL_GET_SHOWTIMES: 'get_showtimes',
    CALL_PLAY_GAME: 'play_game',
    CALL_WATCH_MORE: 'watch_more',
    CALL_SUBSCRIBE: 'subscribe',
    CALL_SIGN_UP: 'sign_up',
    CALL_SHOP_NOW: 'shop_now',
    CALL_LISTEN_NOW: 'listen_now',
    CALL_GET_QUOTE: 'get_quote',
};

const facebookCampaignCallToActionButtonLabel = {
    [facebookCampaignCallToActionButton.CALL_BOOK_NOW]: gettext('Book Now'),
    [facebookCampaignCallToActionButton.CALL_LEARN_MORE]: gettext('Learn More'),
    [facebookCampaignCallToActionButton.CALL_APPLY_NOW]: gettext('Apply Now'),
    [facebookCampaignCallToActionButton.CALL_CONTACT_US]: gettext('Contact Us'),
    [facebookCampaignCallToActionButton.CALL_DOWNLOAD]: gettext('Download'),
    [facebookCampaignCallToActionButton.CALL_GET_OFFER]: gettext('Get Offer'),
    [facebookCampaignCallToActionButton.CALL_GET_SHOWTIMES]: gettext('Get Showtimes'),
    [facebookCampaignCallToActionButton.CALL_PLAY_GAME]: gettext('Play Game'),
    [facebookCampaignCallToActionButton.CALL_WATCH_MORE]: gettext('Watch More'),
    [facebookCampaignCallToActionButton.CALL_SUBSCRIBE]: gettext('Subscribe'),
    [facebookCampaignCallToActionButton.CALL_SIGN_UP]: gettext('Sign Up'),
    [facebookCampaignCallToActionButton.CALL_SHOP_NOW]: gettext('Shop Now'),
    [facebookCampaignCallToActionButton.CALL_LISTEN_NOW]: gettext('Listen Now'),
    [facebookCampaignCallToActionButton.CALL_GET_QUOTE]: gettext('Get Quote'),
};

const companySector = {
    AGENCIES: 'agencies',
    APPS: 'apps',
    ARCHITECTURE_AND_INTERIOR_DESIGN: 'architecture_and_interior_design',
    AUTOMOBILES: 'automobiles',
    BAGS_AND_CASES: 'bags_and_cases',
    BEACH_FASHION: 'beach_fashion',
    BEAUTY: 'beauty',
    BOOKS_AND_BOOKSTORES: 'books_and_bookstores',
    CLEANING: 'cleaning',
    CLOTHING_AND_SHOES: 'clothing_and_shoes',
    CONSULTING: 'consulting',
    COUPON_AND_COLLECTIBLE_SHOPPING: 'coupon_and_collectible_shopping',
    EDUCATION: 'education',
    ELECTRONICS: 'electronics',
    ENGINEERING: 'engineering',
    ENTERTAINMENT: 'entertainment',
    EVENTS_AND_SERVICES_FOR_EVENTS: 'events_and_services',
    FINANCIAL_SERVICES: 'financial_services',
    FLORICULTURE_AND_LANDSCAPING: 'floriculture_and_landscaping',
    FOODS_AND_DRINKS: 'foods_and_drinks',
    FURNITURE: 'furniture',
    HEALTH_AND_WELLNESS: 'health_and_wellness',
    HOME_AND_KITCHEN: 'home_and_kitchen',
    HOME_APPLIANCES: 'home_appliances',
    INDUSTRY: 'industry',
    INTERNET: 'internet',
    INSURANCE: 'insurance',
    LEGAL: 'legal',
    NGO_CROWDFUNDING: 'ngo_crowdfunding',
    PET: 'pet',
    PROPERTIES: 'properties',
    SAAS: 'saas',
    SEX_SHOP: 'sex_shop',
    SOFTWARE_HARDWARE_AND_SERVICE: 'software_hardware_and_service',
    SPORT: 'sport',
    TELECOM: 'telecom',
    TOURISM: 'tourism',
    TOYS: 'toys',
    TRANSPORTATION_AND_WAREHOUSING: 'transportation_and_warehousing',
    UNDERWEAR: 'underwear',
};

const investment = {
    not_yet: 'not_yet',
    500: '500',
    '1k': '1k',
    '3k': '3k',
    '5k': '5k',
    '10k': '10k',
    '25k': '25k',
    '50k': '50k',
    '250k': '250k',
    '1m': '1m',
    '1m+': '1m+',
};

const investmentNames = [{
    label: gettext('Not investing yet'),
    value: 'not_yet',
}, {
    label: gettext('Up to 500'),
    value: '500',
}, {
    label: gettext('Up to 1.000'),
    value: '1k',
}, {
    label: gettext('Up to 3.000'),
    value: '3k',
}, {
    label: gettext('Up to 5.000'),
    value: '5k',
}, {
    label: gettext('Up to 10.000'),
    value: '10k',
}, {
    label: gettext('Up to 25.000'),
    value: '25k',
}, {
    label: gettext('Up to 50.000'),
    value: '50k',
}, {
    label: gettext('Up to 250.000'),
    value: '250k',
}, {
    label: gettext('Up to 1.000.000'),
    value: '1m',
}, {
    label: gettext('Above 1.000.000'),
    value: '1m+',
}];

const role = {
    associate_founder: 'associate_founder',
    director: 'director',
    manager: 'manager',
    coordinator: 'coordinator',
    analyst: 'analyst',
    other: 'other',
};

const abbreviatedObjective = {
    CPA: 'CPA',
    CPC: 'CPC',
    CPM: 'CPM',
    CPV: 'CPV',
    CTR: 'CTR',
    ROAS: 'ROAS',
};

// These objective should be equal as the ones defined in the backend (KPI_CHOICES)
// Be careful when altering them
const objective = {
    focus_on_revenue: 'roas',
    focus_on_conversion: 'cpa',
    focus_site_access: 'cpc',
    focus_on_brand: 'cpm',
};

const objectiveNames = {
    [objective.focus_on_revenue]: gettext('Focus on Revenue (ROAS)'),
    [objective.focus_on_conversion]: gettext('Focus on Conversion (CPA)'),
    [objective.focus_site_access]: gettext('Focus on Site Hits (CPC)'),
    [objective.focus_on_brand]: gettext('Focus on Brand Reach (CPM)'),
};

const typeOfConversions = {
    CALL: 'call',
    SELL: 'sell',
    CART: 'cart',
    CHAT: 'chat',
    CLICK: 'click',
    LEAD: 'lead',
    PAGE_TIME: 'page_time',
    PAGE_VIEW: 'page_view',
};

const typeOfConversionsNames = {
    [typeOfConversions.CALL]: gettext('Call'),
    [typeOfConversions.SELL]: gettext('Sell'),
    [typeOfConversions.CART]: gettext('Cart'),
    [typeOfConversions.CHAT]: gettext('Chat'),
    [typeOfConversions.CLICK]: gettext('Click'),
    [typeOfConversions.LEAD]: gettext('Lead'),
    [typeOfConversions.PAGE_TIME]: gettext('Page Time'),
    [typeOfConversions.PAGE_VIEW]: gettext('Page View'),
};

const automaticCardsDecisions = {
    AUTOMATIC_EXCLUDE_STOP_BLEEDING: 'AUTOMATIC_EXCLUDE_STOP_BLEEDING',
    AUTOMATIC_ADD: 'AUTOMATIC_ADD',
    AUTOMATIC_EXCLUDE: 'AUTOMATIC_EXCLUDE',
    NEGATIVISE_PIECE: 'NEGATIVISE_PIECE',
};

const statusLabel = {
    PAUSED: gettext('Not running'),
    ENABLED: gettext('Running'),
    REMOVED: gettext('Removed'),
};

const statusColors = {
    PAUSED: '#6e7def',
    ENABLED: '#3bbbab',
    REMOVED: '#3687da',
};

const pageMenuItems = {
    ADGROUP: gettext('Ad Group'),
    ACTIVITY: gettext('Activity'),
    BUDGET: gettext('Budget'),
    CAMPAIGN: gettext('Campaign'),
    COST_EFFICIENCY: gettext('Cost Efficiency'),
    CREATIVE: gettext('Creative'),
    PREDICTIONS: gettext('Predictions'),
    THERMOMETER: gettext('Thermometer'),
    INSIGHTS: gettext('Insights'),
    KEYWORD_MONITOR: gettext('Top Keywords'),
    PIPELINE: gettext('Pipeline'),
    RISK_ANALYSIS: gettext('Risk Analysis'),
    SETTINGS: gettext('Settings'),
    SMART_VIEW: gettext('Smart View'),
    WORKFLOW: gettext('Workflow'),
};

const integrationsListItems = {
    ALL: 'All',
    SOCIAL_MEDIA: 'Social Medias',
};

const adTypes = {
    GOOGLE: 'google',
    FACEBOOK: 'facebook',
};

const adItemsTypes = {
    BANNER: 'banner',
    CAROUSEL: 'carousel',
    STORIES: 'stories',
};

const classifications = {
    newUsers: {
        funnelStep: gettext('Top of funnel'),
        label: gettext('New Users'),
        value: 'newUsers',
    },
    conversion: {
        funnelStep: gettext('Bottom of funnel'),
        label: gettext('Conversion'),
        value: 'conversion',
    },
    brand: {
        funnelStep: gettext('Bottom of funnel'),
        label: gettext('Strategic'),
        value: 'brand',
    },
    remarketing: {
        funnelStep: gettext('Bottom of funnel'),
        label: gettext('Remarketing'),
        value: 'remarketing',
    },
    manual: {
        label: gettext('Manual'),
        value: 'manual',
    },
};

let BASE_URL = 'http://localhost:8000';

try {
    switch (process.env.NOof_ENV) {
    case 'development':
        BASE_URL = 'http://localhost:8000';
        break;

    case 'staging':
        BASE_URL = 'https://platform-spa-dev.pareto.io';
        break;

    default:
        BASE_URL = 'https://app.pareto.io';
    }
} catch (ex) {
    console.log(`Exception: ${ex}`);
}

const paymentSuccessful = {
    PAYMENT_SUCCESSFUL: 'Payment successful',
    CREATE_ACCOUNT: 'Create you account now.',
};

const constants = {
    ABBREVIATED_OBJECTIVE: abbreviatedObjective,
    ADDITIONAL_INFORMATION_TYPES: additionalInformationTypes,
    AD_ITEMS_TYPES: adItemsTypes,
    AD_TYPES: adTypes,
    ADS_IN_EXCESS_TYPES: adsInExcessTypes,
    API: { BASE_URL },
    AUTOMATIC_CARDS_DECISIONS: automaticCardsDecisions,
    CAMPAIGN_STATUS_COLORS: statusColors,
    CAMPAIGN_STATUS_LABELS: statusLabel,
    CAMPAIGN_TYPES_LABELS: campaignTypesLabels,
    CAMPAIGN_TYPES: campaignTypes,
    CARD_ACTIVITIES_FORMATTED: cardActivitiesFormatted,
    CARD_ACTIVITIES: cardActivities,
    CARD_AUTOMATION_STATUS: cardAutomaticStatus,
    CARD_CATEGORIES_LABELS: cardCategoriesLabels,
    CARD_CATEGORIES: cardCategories,
    CARD_CONTROL_TYPES_LABELS: cardControlTypesLabels,
    CARD_CONTROL_TYPES: cardControlTypes,
    CARD_FUNNEL_ABBREVIATIONS: cardFunnelAbbreviations,
    FACEBOOK_CAMPAIGN_CALL_TO_ACTION_BUTTON: facebookCampaignCallToActionButton,
    FACEBOOK_CAMPAIGN_CALL_TO_ACTION_BUTTON_LABEL: facebookCampaignCallToActionButtonLabel,
    CARD_FUNNEL_FORMATTED: cardFunnelFormatted,
    CARD_FUNNEL: cardFunnel,
    CARD_MATCH_TYPES: cardMatchTypes,
    CARD_VISIBILITY_LABELS: cardVisibilityLabels,
    CARD_VISIBILITY: cardVisibility,
    COMPANY_NAME: companySector,
    CUSTOMER_JOURNEY_STEPS_DESCRIPTION: customerJourneyDescriptions,
    CUSTOMER_JOURNEY_STEPS: customerJourneySteps,
    FILTERS_NAMES: filtersNames,
    FILTERS: filters,
    FOCUS: focus,
    CLASSIFICATIONS: classifications,
    HISTORY_OPTIONS_FORMATTED: historyOptionsFormatted,
    HISTORY_OPTIONS: historyOptions,
    INTEGRATIONS_LIST_ITEMS: integrationsListItems,
    INVESTMENT_NAMES: investmentNames,
    INVESTMENT: investment,
    KPIS: kpis,
    MODES: modes,
    NO_KPI_TEXT: '---',
    OBJECTIVE_NAME: objectiveNames,
    SEGMENT_TYPES: segmentTypes,
    PAGE_MENU_ITEMS: pageMenuItems,
    PRIORITIES_LABELS: cardPrioritiesLabels,
    PRIORITIES: priorities,
    PRIORITIES_WITH_ICONS: prioritiesWithIcons,
    QUALITY_SCORE_PROVIDERS_TYPES: qualityScoreProvidersTypes,
    ROLE: role,
    SIDEBAR_MODAL_ATTRIBUTES: sidebarModalAttributes,
    PAYMENT_SUCCESSFUL: paymentSuccessful,
    STATUS: status,
    STATUS_LABELS: statusLabels,
    TYPE_OF_CONVERSIONS_NAMES: typeOfConversionsNames,
    TYPE_OF_CONVERSIONS: typeOfConversions,
};

export default constants;
